// extracted by mini-css-extract-plugin
export default {"workcell":"workcell-V7Bcz","header":"header-SjFi_","tabPanel":"tabPanel-kbI97","schedule":"schedule-xRBA_"};